import React, { useEffect } from 'react';

const AdUnit = ({ adSlot }) => {
  // Use a unique key to force React to re-render the ad container 
  // when the page changes, which is necessary for AdSense to load a new ad.
  const adKey = `${window.location.pathname}-${adSlot}`; 
  
  useEffect(() => {
    // This runs after the component mounts and ensures the ad script is notified 
    // to search for and render ads inside the newly injected <ins> tag.
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error("AdSense push error:", e);
    }
  }, [adKey]); // Re-run effect when the ad container (key) changes

  // The raw HTML of the ad unit as provided by AdSense
  const adCode = `
    <ins class="adsbygoogle"
         style="display:block" 
         data-ad-client="ca-pub-2693559491094249" 
         data-ad-slot="${adSlot}" 
         data-ad-format="auto" 
         data-full-width-responsive="true"></ins>
  `;

  return (
    // Use dangerouslySetInnerHTML to inject the raw HTML and bypass React style validation
    <div 
      key={adKey}
      className="adsense-container" 
      style={{ margin: '20px auto', textAlign: 'center' }}
      dangerouslySetInnerHTML={{ __html: adCode }} 
    />
  );
};

export default AdUnit;